import { useEffect, useState } from "react";
import { Dialog } from "../Dialog";
import { SimpleButton, SimpleContainer, SimplePageTemplate } from "./SimpleElements"
import { useUser } from "../../../biz/hooks/entities/useUser";
import { useOrganization, useOrganizationActions } from "../../../biz/hooks/entities/useOrganization";
import { useNavigate } from "react-router-dom";
import { Config } from "../../../biz/data/Config";
import { useDialogs } from "./MesssageBoxes";
import { useTranslation } from "react-i18next";

export const SimpleHome = () => {

    const nav = useNavigate();
    const [visible, setVisible] = useState<boolean>(false);

    const user = useUser();
    const org = useOrganization();
    const orgActions = useOrganizationActions();

    const { t } = useTranslation();
    const dialogs = useDialogs();

    const onLogoutClick = () => {
        nav(Config.routes.start);
        user.logOut();
    }
    useEffect(() => {
        if (user?.loggedIn) {
            nav(Config.routes.simple_profile);
        }
    }, [, user?.loggedIn])


    return (
        <SimplePageTemplate>
            <h1></h1>
        </SimplePageTemplate>
    )

    return (
        <SimplePageTemplate>
            <h1>
                {t("leftmenu_section_start")}
            </h1>

            <hr />
            <h3>
                Valt företag:
            </h3>
            <div className="flex">
                {Object.keys(org.allOrganizations ?? {}).map(key => org.allOrganizations?.[key])?.map(o => (
                    <div key={o?.id} className="flex-item">

                        {org.myOrganizationRoles?.[o?.id ?? ""]?.role}

                        <SimpleButton
                            label={o.name + " (" + org.getOrganizationProStatus(o?.id) + ")"}
                            onClick={() => {
                                orgActions.switchToOrganization(o?.id ?? "");
                                nav(Config.routes.simple_profile);
                            }} type={org?.currentOrganization?.id === o.id ? "primary" : "secondary"}
                            icon={org?.currentOrganization?.id === o.id ? "check" : "pen"}
                        />
                    </div>
                ))}
            </div>
            <hr />
            <h3>
                Valt Språk:
            </h3>
            <div className="flex">
                {/* {lang.availableLanguages.map(o => (
                    <div key={o?.id} className="flex-item">
                        <SimpleButton
                            label={o.name + " (" + o.id + ")"}
                            onClick={() => { lang.setLanguage(o.id) }}
                            type={lang.selectedLanguage === o.id ? "primary" : "secondary"}
                            icon={lang.selectedLanguage === o.id ? "check" : "pen"}
                        />
                    </div>
                ))} */}
            </div>

            <hr />

            <div>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dignissim dolor tristique, interdum tellus non, faucibus velit. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nulla et tincidunt eros, quis volutpat libero. Fusce finibus vitae augue vitae accumsan. Praesent in facilisis lorem. Nullam id tempor libero, ac ultrices felis. Donec ut lacinia neque. Proin sed auctor mi.
                </p>

                <p>
                    Proin mollis finibus dui nec faucibus. Ut interdum cursus dolor, eget eleifend nunc mattis at. Nullam iaculis a nisi nec faucibus. Curabitur pellentesque hendrerit orci, sit amet rutrum nisl rhoncus non. In viverra vehicula mauris nec laoreet. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent molestie augue ac libero interdum efficitur. Quisque sollicitudin nisi eu tempor auctor. In id ex ut lorem eleifend luctus eu vel ante. Suspendisse hendrerit porta odio vel efficitur. Etiam auctor dapibus turpis, posuere ultricies urna semper id. Aliquam gravida sollicitudin leo a porttitor. Fusce convallis nec velit in auctor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                </p>

                <p>
                    Proin mollis finibus dui nec faucibus. Ut interdum cursus dolor, eget eleifend nunc mattis at. Nullam iaculis a nisi nec faucibus. Curabitur pellentesque hendrerit orci, sit amet rutrum nisl rhoncus non. In viverra vehicula mauris nec laoreet. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent molestie augue ac libero interdum efficitur. Quisque sollicitudin nisi eu tempor auctor. In id ex ut lorem eleifend luctus eu vel ante. Suspendisse hendrerit porta odio vel efficitur. Etiam auctor dapibus turpis, posuere ultricies urna semper id. Aliquam gravida sollicitudin leo a porttitor. Fusce convallis nec velit in auctor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                </p>

                <p>
                    Proin mollis finibus dui nec faucibus. Ut interdum cursus dolor, eget eleifend nunc mattis at. Nullam iaculis a nisi nec faucibus. Curabitur pellentesque hendrerit orci, sit amet rutrum nisl rhoncus non. In viverra vehicula mauris nec laoreet. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent molestie augue ac libero interdum efficitur. Quisque sollicitudin nisi eu tempor auctor. In id ex ut lorem eleifend luctus eu vel ante. Suspendisse hendrerit porta odio vel efficitur. Etiam auctor dapibus turpis, posuere ultricies urna semper id. Aliquam gravida sollicitudin leo a porttitor. Fusce convallis nec velit in auctor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                </p>

                <p>
                    Proin mollis finibus dui nec faucibus. Ut interdum cursus dolor, eget eleifend nunc mattis at. Nullam iaculis a nisi nec faucibus. Curabitur pellentesque hendrerit orci, sit amet rutrum nisl rhoncus non. In viverra vehicula mauris nec laoreet. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent molestie augue ac libero interdum efficitur. Quisque sollicitudin nisi eu tempor auctor. In id ex ut lorem eleifend luctus eu vel ante. Suspendisse hendrerit porta odio vel efficitur. Etiam auctor dapibus turpis, posuere ultricies urna semper id. Aliquam gravida sollicitudin leo a porttitor. Fusce convallis nec velit in auctor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                </p>
            </div>

            <div>
                {JSON.stringify(org.currentOrganization)}
            </div>

            <SimpleButton
                onClick={onLogoutClick}
                label={"Logga ut"}
                type="secondary"
                icon="none" />


            <hr />

            <div className="button-row">

                <SimpleButton
                    onClick={() =>
                        dialogs.showInfo(
                            "Info",
                            "Ditt utbud visas på din profilsida och är tänkt fungera som ett skyltfönster, och bör endast visa ett axplock av de varor eller tjänster du erbjuder.")
                    }
                    label={"Info"}
                    icon="none" />

                <SimpleButton
                    onClick={() =>
                        dialogs.showWarning(
                            "Max 10 poster",
                            "Ditt utbud visas på din profilsida och är tänkt fungera som ett skyltfönster, och bör endast visa ett axplock av de varor eller tjänster du erbjuder.")
                    }
                    label={"Varning"}
                    icon="none" />

                <SimpleButton
                    onClick={() =>
                        dialogs.showConfirm(
                            "Confirm",
                            "Ditt utbud visas på din profilsida och är tänkt fungera som ett skyltfönster, och bör endast visa ett axplock av de varor eller tjänster du erbjuder.",
                            () => alert("Ok"),
                            () => alert("Cancel")
                        )
                    }
                    label={"Confirm"}
                    icon="none" />

            </div>


            <hr />

            <div hidden={user.isOrganizationAdministrator !== true}>
                Roll: ORGANIZATIONADMINISTRATOR
            </div>
            <div hidden={user.isDeveloper !== true}>
                Roll: DEVELOPER
            </div>


        </SimplePageTemplate>
    )
}